import { customAxios, IDUSUARIO, FDV_URL, USERNAME  } from '../constants';

export default function(codCortesiaComercial,numFichaVtaVeh) {

    const config = {
      params: {
        codCortesiaComercial:codCortesiaComercial
      },
      headers: {
        codUsuario: USERNAME,
        idUsuario: IDUSUARIO,

      }
    };


    return customAxios.delete(`${FDV_URL}/ficha-venta/fichas-venta/${numFichaVtaVeh}/adicionales`, config);
}



// WEBPACK FOOTER //
// ./src/utils/inactivarEquiposCortersia.js